"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@user-admin-platform-bulk/success",
  ERROR: "@@user-admin-platform-bulk/error",
  RESET: "@@user-admin-platform-bulk/reset",
  ACTIVATE: "@@user-admin-platform-bulk/activate",
  DEACTIVATE: "@@user-admin-platform-bulk/deactivate",
  HARD_DELETE: "@@user-admin-platform-bulk/hard-delete",
  SOFT_DELETE: "@@user-admin-platform-bulk/soft-delete",
  RESTORE: "@@user-admin-platform-bulk/restore"
};
exports.actionTypes = actionTypes;